import { NODE_WIDTH } from './Sizes';

export const TIER_OFFSET_X = 12;
export const TIER_OFFSET_Y = 25;
export const TIER_BADGE_OFFSET_X = 4;
export const TIER_BADGE_OFFSET_Y = 110;
export const MACHINE_NAME_OFFSET_X = NODE_WIDTH / 2;
export const MACHINE_NAME_OFFSET_Y = -15;
export const EFFICIENCY_OFFSET_X = 140;
export const EFFICIENCY_OFFSET_Y = 127;
export const MACHINE_OFFSET_X = 72;
export const MACHINE_OFFSET_Y = 72;
export const BADGE_OFFSET_X = 85;
export const BADGE_OFFSET_Y = 110;
export const RECIPE_OFFSET_X = NODE_WIDTH / 2;
export const RECIPE_OFFSET_Y = 155;
export const RECIPE_FONT_OFFSET = 0;
export const HIGHLIGHT_OFFSET_X = -9;
export const HIGHLIGHT_OFFSET_Y = -9;
